module.exports = __webpack_public_path__ + "img/ribbon.4b21128b.svg";